// projectBlocks.js
// PROJECT_TYPE_SHOW (types.js) controls if type selection shows

const projectBlocks = [
  {
    id: 1, block_name: "Project Information", block_key: "information",
    block_icon: "info", is_project_show: true, block_type: "fields",
  },
  {
    id: 2, block_name: "Land Area Detail", block_key: "land_area",
    block_icon: "plan", is_project_show: true, block_type: "land_area",
  },
  {
    id: 3, block_name: "Project Image", block_key: "images",
    block_icon: "image", is_project_show: true, block_type: "fields",
  },
  {
    id: 10, block_name: "Documents", block_key: "documents",
    block_icon: "document", is_project_show: true, block_type: "documents",
  },
  {
    id: 4, block_name: "Project Video", block_key: "video",
    block_icon: "video", is_project_show: true, block_type: "video",
    enable_toggle: true, toggle_field: "enable_video_section", default_enabled: false,
  },
  {
    id: 5, block_name: "Project Location", block_key: "location",
    block_icon: "location", is_project_show: true, block_type: "location",
  },
  {
    id: 6, block_name: "Amenities", block_key: "aminities",
    block_icon: "amenities", is_project_show: true, block_type: "amenities",
  },
  {
    id: 7, block_name: "Nearest Location", block_key: "nearest_location",
    block_icon: "nearest", is_project_show: true, block_type: "key_value",
    left_label: "Nearest Location", right_label: "Distance (km)",
    left_field: "near_id", right_field: "distance",
    left_type: "nearest_dropdown", right_type: "number",
  },
  {
    id: 8, block_name: "Additional Information", block_key: "additional_info",
    block_icon: "additional", is_project_show: true, block_type: "key_value",
    left_label: "Key", right_label: "Value",
    left_field: "info_key", right_field: "info_value",
    left_type: "text", right_type: "text",
  },
  // ✅ புதிய Company Profile block
  {
    id: 11, block_name: "Company Profile", block_key: "company_profile",
    block_icon: "company", is_project_show: true, block_type: "company_profile",
  },
  {
    id: 9, block_name: "SEO Information", block_key: "seo",
    block_icon: "seo", is_project_show: false, block_type: "fields",
  },
];

export default projectBlocks;